import { createAction } from 'redux-actions';

export const SCROLL_TO_PROMPT = 'SCROLL_TO_PROMPT';
export const scrollToPrompt = createAction(SCROLL_TO_PROMPT);
